import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Image from 'components/Image';
import Loading from 'components/Loading';
import Modal from 'components/Modal';
import PurchaseResult from 'components/Fate/components/PurchaseModal/PurchaseResult';

import CostRubric from './CostRubric';

// export default function ConfirmModal(props) {
export default class ConfirmModal extends Component {
  state = {
    isFree: false,
  }

  componentDidMount = () => {
    // The reason we want isFree to be allowed to go stale is that the criterion on
    // which it's initially based — ownership of a Licence to Amend Your Face —
    // changes over the course of the modal's lifetime (a successful face change removes
    // it). We don't want the result content to suggest to the user that they spent
    // Fate, so we'll let this go stale.
    const { isFree } = this.props;
    this.setState({ isFree });
  }

  renderButtonLabel = () => {
    const {
      fateCost,
      isSubmitting,
    } = this.props;

    const { isFree } = this.state;

    if (isSubmitting) {
      return <Loading spinner small />;
    }

    if (isFree) {
      return 'Select';
    }

    return `${fateCost} Fate`;
  }

  renderContent = () => {
    const {
      avatar,
      fateCost,
      isSuccess,
      message,
      onConfirm,
      onRequestCloseModalStack,
      purchaseComplete,
    } = this.props;

    const { isFree } = this.state;

    if (purchaseComplete) {
      return (
        <PurchaseResult
          image={avatar}
          name={avatar}
          isFree={isFree}
          isSuccess={isSuccess}
          message={message}
          onClick={onRequestCloseModalStack}
          type="cameo"
        />
      );
    }

    return (
      <div>
        <h3 className="heading heading--2" style={{ color: '#000' }}>Change your face?</h3>
        <hr />
        <div className="media dialog__media">
          <div className="media__content">
            <div className="media__left">
              <div>
                <Image className="media__object" icon={avatar} alt={avatar} width={78} height={100} type="cameo" />
              </div>
            </div>
            <div className="media__body">
              <p>Are you sure?</p>
              <CostRubric isFree={isFree} fateCost={fateCost} />
            </div>
            <hr />
          </div>
          <div className="dialog__actions">
            <button
              className={classnames(
                'button',
                isFree ? 'button--primary' : 'button--secondary',
              )}
              onClick={onConfirm}
              type="button"
            >
              {this.renderButtonLabel()}
            </button>
          </div>
        </div>
      </div>
    );
  }

  render = () => {
    const { isOpen, onConfirm, onRequestClose } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onConfirm={onConfirm}
        onRequestClose={onRequestClose}
      >
        {this.renderContent()}
      </Modal>
    );
  }
}

ConfirmModal.propTypes = {
  avatar: PropTypes.string.isRequired,
  fateCost: PropTypes.number.isRequired,
  isFree: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isSuccess: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onRequestCloseModalStack: PropTypes.func.isRequired,
  purchaseComplete: PropTypes.bool.isRequired,
};

ConfirmModal.defaultProps = {
  message: undefined,
};